import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["dismiss"]

  setHighlight(event) {
    event.preventDefault()
    const target = event.detail.element || event.target
    const container = target && target.closest(".highlight-container") || target.querySelector(".highlight-container")
    container && this.#displayHighlight(target, container)
  }

  highlightFromAnchor(event) {
    event.preventDefault()
    const target = event.currentTarget
    const container = target && target.closest(".highlight-container")
    container && this.#displayHighlight(target, container)
    this.#copyToClipboard(target)
  }

  highlightInDoc(event) {
    event.preventDefault()
    const property = event.currentTarget
    const propertyId = property.dataset.anchor

    const docProperty = this.element.querySelector(`.explorer-doc #${propertyId}`)

    if (docProperty) {
      this.dispatch("goTo", { target: document, detail: { element: docProperty }, prefix: false })
      this.#displayHighlight(docProperty, docProperty.closest(".highlight-container"), {block: "center"})
    }
  }

  dismiss(event) {
    if (!event.target.closest(".anchor-link") && !event.target.closest("dialog")) {
      const container = document.querySelector(".shared")
      this.#removeHighlight(container)
    }
  }

  #displayHighlight(target, container) {
    this.#removeHighlight(this.element.querySelector(".shared"))
    container.classList.add("shared")
    this.#appendDismissButton(container)
  }

  #appendDismissButton(container) {
    if (!this.hasDismissTarget) {
      return false
    }

    if (!container.querySelector(":scope > .dismiss-highlight")) {
      container.appendChild(document.importNode(this.dismissTarget.content, true))
    }
  }

  #removeHighlight(container) {
    container && container.classList.remove("shared")
  }

  #copyToClipboard(link) {
    const href = link.getAttribute("href")
    history.pushState({}, "", href)
    navigator.clipboard.writeText(window.location)
    link.classList.add("active")

    setTimeout(() => {
      link.classList.remove("active")
    }, 2000)
  }
}
